import PersonComparisonModel from './../../model/personComparisonModel';
import MainController from '../../../../controller/MainController';
import styles from './results.module.scss';
import template from './results.tpl';
import {gsap} from 'gsap';
import ResultDiagram from './../../../../components/resultdiagram/resultDiagram';
import Tooltip from '../../../../components/tooltip/tooltip';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let nextButtonHandler: ((event: any) => void) | null = null;

export default class Results {

    private data: any;
    private template: string;
    private diagrams: any;
    private target!: HTMLElement;
    private diagram_containers: any;

    constructor(data) {

        this.data = data;
        this.template = template({data: data, styles: styles});


        nextButtonHandler = (event) => this.stepComplete(event);
    }

    init(data) {

        this.diagrams = this.setDiagrams();
        this.data = data;

        // enable sharing for this view/step
        MainController.setSharing(true);
    }

    getDifferenceText(prognosis, estimate) {

        let operator = prognosis < estimate ? '- ' : '+ ';
        return operator + Math.abs(Math.round(prognosis - estimate));
    }

    setDiagrams() {
        let diagrams = {};
        let minAge = 60;
        let maxAge = 109;

        Object.values(PersonComparisonModel.people).forEach((person: any) => {

            let prognosis = PersonComparisonModel.getResultsByBirthdayAndGender(person.birthyear, person.gender);

            diagrams[person.id] = new ResultDiagram(minAge, maxAge, prognosis['20'], prognosis['50'], prognosis['80'], prognosis.k, person.estimated_age);
            diagrams[person.id].appendTo(this.diagram_containers[person.id].diagram);

            this.diagram_containers[person.id].name.innerHTML = person.name;
            this.diagram_containers[person.id].difference.innerHTML = this.getDifferenceText(prognosis.k, person.estimated_age);
        });

        return diagrams;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    stepComplete(_event: any) {
        /*
         Currently not needed.
         */
    }

    show(timeline, onComplete) {

        timeline.add([

            gsap.to(this.target, 0.2, {autoAlpha: 1, display: '', onComplete: onComplete})
        ]);
    }

    hide(timeline, onComplete) {
        /*
         Currently not needed.
         */

        onComplete();
    }


    appendTo(target) {

        this.target = target;
        this.target.setAttribute('id', this.data.steps.results.id);
        this.target.innerHTML = this.template;

        // Collect DOM references
        let left = this.target.querySelectorAll('.results_container > .left')[0];
        let right = this.target.querySelectorAll('.results_container > .right')[0];

        this.diagram_containers = {
            left: {
                diagram: left,
                name: left.querySelectorAll('span.name')[0],
                difference: left.querySelectorAll('span.difference')[0],
            },
            right: {
                diagram: right,
                name: right.querySelectorAll('span.name')[0],
                difference: right.querySelectorAll('span.difference')[0],
            }
        };
        const tooltip = new Tooltip(this.data.source_tooltip.link,this.data.source_tooltip.headline,
          this.data.source_tooltip.text );
        tooltip.appendTo(this.target.querySelector('div.source_tooltip'));
    }
}
